import React, { useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import SharpwatchIntroductionVideo from "assets/images/SharpwatchIntroductionVideo.mp4";

function Slide12() {
  const videoRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    const container = containerRef.current;

    if (!video || !container) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            // Confirm video is still in DOM and ready to play
            if (video && video.readyState >= 3) {
              video.play().catch((err) => {
                console.warn("Autoplay failed:", err.message);
              });
            }
          }); // slight delay allows video element to mount
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(container);

    return () => observer.disconnect();
  }, []);

  return (
    <MDBox textAlign="center" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        ref={containerRef}
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1350px" }}
        margin="0 auto"
        px={{ xs: 2, md: 3 }}
        py={3}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRadius: "12px",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(24px, 5vw, 32px)",
            fontWeight: "bold",
            marginBottom: "20px",
            color: "white",
          }}
        >
          Introduction to Sharpwatch®
        </h1>

        <MDBox
          width="100%"
          maxWidth="1000px"
          borderRadius="12px"
          overflow="hidden"
          sx={{
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)",
            backgroundColor: "black",
          }}
        >
          <video
            ref={videoRef}
            width="100%"
            height="auto"
            controls
            playsInline
            controlsList="nodownload"
            style={{
              display: "block",
              borderRadius: "12px",
              border: "none",
            }}
          >
            <source src={SharpwatchIntroductionVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Slide12;
